export const isRelativeDate = (value: unknown) => {
	return (
		typeof value === "string" &&
		(value.startsWith("-") || value.startsWith("+")) &&
		!Number.isNaN(Number(value))
	);
};
